import { RouteRecordRaw } from "vue-router";
import { PAGE_TYPE } from "@supplier/meta";

const dataAnalysisRouter: RouteRecordRaw[] = [
    {
        path: "/dataAnalysis",
        name: "DataAnalysis",
        component: () => import("@/views/layouts/index.vue"),
        redirect: "/dataAnalysis/dashboard",
        meta: {
            title: "数据分析",
            icon: "icon-zhishu"
        },
        children: [
            {
                path: "/dataAnalysis/dashboard",
                name: "Dashboard",
                component: () => import("@/views/pages/dataAnalysis/dashboard/index.vue"),
                meta: {
                    title: "数据看板",
                    isNotShowHeader: true,
                    hideMenu: true,
                    hideTabs: true,
                    hideHeader: true,
                    openNewPage: true
                }
            },
            {
                path: "/dataAnalysis/screen",
                name: "SupervisionScreen",
                component: () => import("@/views/pages/dataAnalysis/supervisionScreen/index.vue"),
                meta: {
                    title: "监管大屏",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.LIST.code
                }
            },
            {
                path: "/dataAnalysis/logistics",
                name: "LogisticsAnalysis",
                component: () => import("@/views/pages/dataAnalysis/logisticsAnalysis/index.vue"),
                meta: {
                    title: "物流分析",
                    isNotShowHeader: true,
                    pageType: PAGE_TYPE.LIST.code
                }
            }
        ]
    }
];

export default dataAnalysisRouter;
